import { render, staticRenderFns } from "./InfoSpouse.vue?vue&type=template&id=5507face&scoped=true"
import script from "./InfoSpouse.vue?vue&type=script&lang=js"
export * from "./InfoSpouse.vue?vue&type=script&lang=js"
import style0 from "./InfoSpouse.vue?vue&type=style&index=0&id=5507face&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5507face",
  null
  
)

/* custom blocks */
import block0 from "./InfoSpouse.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports